import { type ClassValue, clsx } from "clsx"
import { UseFormReturn } from "react-hook-form"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function runWorker<TInput, TContext, TResult>(workerFactory: () => Worker, data: TInput, context?: TContext): Promise<TResult> {
  return new Promise((resolve, reject) => {
    const worker = workerFactory() // Inicializa o Worker a partir da fábrica fornecida

    // Escuta a resposta do Worker
    worker.onmessage = (event) => {
      resolve(event.data as TResult) // Resolve a Promise com o resultado do Worker
      worker.terminate() // Finaliza o Worker
    }

    // Escuta erros no Worker
    worker.onerror = (error) => {
      reject(error) // Rejeita a Promise em caso de erro
      worker.terminate() // Finaliza o Worker
    }

    // Envia os dados para o Worker
    worker.postMessage({
      data,
      context: Object.entries(context || {}).reduce((acc, [key, value]) => ({ ...acc, [key]: value?.toString() }), {}),
    })
  })
}

export const extractResponseErrorMessage = (error: any) => {
  // console.log('error', error)
  // if (error.code === 500) {
  //   return 'Something went wrong.'
  // }

  let message

  if (error?.response?.data?.error?.name === "ZodError") {
    message = extractZodErrorMessage(error?.response?.data?.error)
  } else {
    message = error?.response?.data?.message || error?.message
  }


  return message
}

export const extractZodErrorMessage = (error: any) => {
  return error?.issues?.[0]?.path?.join(".") + " - " + error?.issues?.[0]?.message
}

export function timeout(delay: any) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay)
  })
}

export function clone(obj) {
  if (!obj) return obj
  return JSON.parse(JSON.stringify(obj))
}

type GeneratorFunction<T> = (index: number) => T
export function generateFakeData<T>(quantity: number, generator: GeneratorFunction<T>): T[] {
  const data: T[] = []

  for (let i = 0; i < quantity; i++) {
    data.push(generator(i))
  }

  return data
}

/**
 * Define um valor em um objeto, criando o caminho necessário se não existir
 * @param obj Objeto base
 * @param path Caminho para a propriedade (pode ser string com pontos ou array)
 * @param value Valor a ser definido
 */
export function setNestedValue<T extends Record<string, any>>(
  obj: T,
  path: string | string[],
  value: any
): T {
  const keys = Array.isArray(path) ? path : path.split('.');
  const copy = { ...obj };
  let current = copy;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    if (!(key in current)) {
      current[key] = {};
    }
    current = current[key];
  }

  const lastKey = keys[keys.length - 1];
  current[lastKey] = value;

}

export function setFieldValueSafe(path: string, value: any, form: UseFormReturn<any, any, undefined>) {
  // const newValues = setNestedValue(
  //   form.values,
  //   path,
  //   value
  // );
  // form.setValues(newValues);
  // const newValues = setNestedValue(
  //   form.getValues(),
  //   path,
  //   value
  // );
  form.setValue(path, value);
}

export function slugify(text: string) {
  return text.toString().toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}

// Função para codificar JSON para Base64
export function encodeJsonToBase64(jsonObj) {
  const jsonString = JSON.stringify(jsonObj) // Converte JSON para string
  return btoa(encodeURIComponent(jsonString)) // Codifica para Base64
}

// Função para decodificar Base64 para JSON
export function decodeBase64ToJson(base64String) {
  const jsonString = decodeURIComponent(atob(base64String)) // Decodifica para string
  return JSON.parse(jsonString) // Converte para JSON
}

export function getUniqueName(name: string, list: string[]) {
  let nameUnique = name
  let i = 1
  while (list.find((existingName) => existingName === nameUnique)) {
    nameUnique = name + " (" + i + ")"
    i++
  }
  return nameUnique
}